<div class="popup-global-layout width-650 p-4 p-md-5">
  <div *ngIf="currentStep == 0">
    <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
    <div class="global-title">

    <ng-container *ngIf="isAutoPay; else unenrollTemplate">
      <p class="info">Are you sure you want to enroll in Auto Pay? </p>
    </ng-container>
    
    <ng-template #unenrollTemplate>
      <div class="info">Are you sure you want to stop Auto Pay ?</div>
      <div class="global-yellow-bar"></div>
    </ng-template>
   </div>
    

<ng-container *ngIf="isAutoPay; else unenrollContent">
  <div class="global-yellow-bar"></div>
  <div class="global-subtitle">Auto Pay Enrollment</div>
  <div class="global-text">
    <p>You are about to enroll in Auto Pay. Your primary payment method will be charged automatically.</p>
  </div>
</ng-container>

<ng-template #unenrollContent>
  <div class="global-text">
    <p>By unenrolling from Auto Pay, you will need to make manual one-time payments.</p>
  </div>
</ng-template>


  <ng-template #unenrollContent>
    <div class="global-text">
      <p>By unenrolling in Auto Pay, you will now need to submit manual one-time payments</p>
    </div>
  </ng-template>

    <div class="global-button-format">
      <button class="dw-primary-button icon-right" (click)="confirmRedeem()" *ngIf="!buttonLoading">Continue<mat-icon class="black">keyboard_arrow_right</mat-icon></button>
      <button class="dw-primary-button icon-right" disabled *ngIf="buttonLoading">Continue<span class="spinner-border"></span></button>
      <button class="dw-secondary-button icon-right" (click)="close()">Cancel<mat-icon class="blue">keyboard_arrow_right</mat-icon></button>
    </div>
    <div class="errors" *ngIf="systemError">Something went wrong! Please try again later.</div>
  </div>
  
  <div *ngIf="currentStep == 1">
    <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
    <div class="global-title">Update Confirmed!</div>
    <div class="global-yellow-bar"></div>

    <div class="global-subtitle">
      <ng-container *ngIf="skipConfirmation && skipFirstStep">
        Your Primary Auto pay Card has been successfully set up for Auto Pay! This method will be used to charge any upcoming invoices.
      </ng-container>
      
      <ng-container *ngIf="!skipConfirmation || !skipFirstStep">
        Your Autopay preferences were saved successfully.
      </ng-container>
    </div>
    
    <div class="global-button-format">
      <button (click)="thankYou()" class="dw-primary-button icon-right">Thank You<mat-icon class="black">keyboard_arrow_right</mat-icon></button>
    </div>
  </div>
</div>